import { BaseStore } from "stores/base_store"
import { runInAction, makeAutoObservable } from "mobx"
import { api_get } from "api/utils"
import { CursorType } from "utils/types"

export type FHRequestAttachmentType = {
    key: string;
    uuid: string;
    user: string;
    request: string;
    message: string;

    google_cloud_storage_location: string;
    filename: string;
    filesize: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: FHRequestAttachmentType) => void;
};

// Domain object FHRequestAttachment
export class FHRequestAttachment implements FHRequestAttachmentType {
    key = "";
    uuid = "";
    user = "";
    request = "";
    message = "";

    google_cloud_storage_location = "";
    filename = "";
    filesize = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: FHRequestAttachmentType) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: FHRequestAttachmentType) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class FHRequestAttachmentStore extends BaseStore<FHRequestAttachmentType, FHRequestAttachment> {



    async fetchListByRequest(request: string, cursor?: CursorType): Promise<FHRequestAttachmentType[]>  {
        const url = "/request-attachment/list/by-request";
        const data = { request, cursor: cursor || "" };

        const response = await api_get(url, data);
        if (response.ok) {
            const data = await response.json();
            this.receiveUpdate(data.items);
            if(data?.cursor) {
                this.fetchListByRequest(request, data.cursor);
            }
            // This returns as possibly incomplete list due to the cursor,
            // but FHRequestStore.items is complete when .then() is called
            // so you can/should just use that.
            return data.items;
        }
        return [];
    };

    async fetchSignedUrl(attachment: string, disposition: string): Promise<string|null>  {
        const url = "/request-attachment/get-signed-url";
        const data = { attachment, disposition };

        const response = await api_get(url, data);
        if (response.ok) {
            const data = await response.json();
            return data['signed-url'];
        }
        return null;
    };

    modelConstructor() {
        return FHRequestAttachment;
    }

}
